module.exports = __webpack_public_path__ + "img/744.d2903170.jpg";